import type { Person } from '../../modules/eventsApi/persons/person'
import type { Appointment } from '../../modules/schedulerApi/appointments/appointment'
import type { AppointmentItem } from '../../modules/schedulerApi/appointments/appointment-item'
import type { AppointmentStatus } from '../../modules/schedulerApi/appointments/appointments.enum'

export class AppointmentsSelectEntity {
    constructor() {
        this.appointments = []
    }
    statusAttended: boolean
    appointments: AppointmentsSelectAppointmentEntity[]
}

export class AppointmentsSelectAppointmentEntity {
    selected: boolean
    personId: string
    person?: Person
    appointment: Appointment
    items: {
        selected: boolean
        item: AppointmentItem
    }[]
}
